import { useState } from 'react'
import Project from '../project'
import _data from '../utils/_data'
import moment from 'moment'
import { BookingCategory, TimeSlot } from 'common/types/MemberBooking'

export const useGetAvailability = (bookingCategory: BookingCategory) => {
  const [slots, setSlots] = useState<TimeSlot[]>([])

  const fetchSlots = async (date: Date, profileId: string) => {
    const selectedDate = date.toISOString().split('T')[0]

    if (bookingCategory === BookingCategory.DOCUMENT_REVIEW) {
      setSlots(generateManualSlots(selectedDate))
      return
    }

    const res = await fetch(
      `${Project.liveApi}legal-services/lawyers/profiles/${profileId}/availability/?on_date=${selectedDate}&duration_minutes=60`,
      {
        method: 'GET',
        headers: {
          AUTHORIZATION: `Bearer ${_data.token}`,
        },
      },
    )

    if (!res.ok) {
      console.error('Failed to fetch slots (generating manual slots):', res.status, res.statusText)
      setSlots(generateManualSlots(selectedDate))
      return
    }

    try {
      const timeSlots = await res.json()
      if (!timeSlots || timeSlots.length === 0) {
        console.warn('Empty or missing data (generating manual slots).')
        setSlots(generateManualSlots(selectedDate))
        return
      }

      const transformedSlots: TimeSlot[] = timeSlots.map((slot: { start: string; end: string }) => ({
        start: moment(slot.start).local().format('HH:mm'),
        end: moment(slot.end).local().format('HH:mm'),
      }))
      setSlots(transformedSlots)
    } catch (error) {
      console.error('Error parsing JSON (generating manual slots):', error)
      setSlots(generateManualSlots(selectedDate))
    }
  }

  const generateManualSlots = (date: string): TimeSlot[] => {
    const slots: TimeSlot[] = []
    // NOTE these are in the users local timezone for a normal 9-5 day (will be converted to UTC on POST)
    for (let hour = 9; hour < 18; hour++) {
      const start = moment(`${date} ${hour}:00`, 'YYYY-MM-DD HH:mm').format('HH:mm')
      const end = moment(`${date} ${hour}:30`, 'YYYY-MM-DD HH:mm').format('HH:mm')
      slots.push({ start, end })
    }
    return slots
  }

  return { slots, fetchSlots }
}
